import http from "./http-common";
import qs from "qs";
import InfographicModel from "../models/infographic";

// eslint-disable-next-line
export default new (class InfographicService {
  /** หน้ารวม — ใหม่สุดก่อน แบ่งหน้าฝั่ง Strapi */
  async getInfographics({ page = 1, pageSize = 12 }) {
    const query = qs.stringify(
      {
        sort: ["publishedAt:desc"],
        pLevel: 5,
        pagination: { page, pageSize },
      },
      { encodeValuesOnly: true }
    );
    return await http
      .get("/infographics?" + query)
      .then(async (response) => {
        const data = await Promise.all(
          response.data.data.map((item) => InfographicModel.get(item))
        );
        return [data, response.data.meta];
      })
      .catch((error) => {
        console.log(error);
        return [[], {}];
      });
  }

  /** หน้ารายละเอียด — status=draft ใช้ตอนกด Preview จาก Strapi */
  async getInfographicBySlug(slug, status = "published") {
    const query = qs.stringify(
      { filters: { Slug: { $eq: slug } }, pLevel: 5, status },
      { encodeValuesOnly: true }
    );
    return await http
      .get("/infographics?" + query)
      .then(async (response) => {
        const row = response.data.data[0];
        return row ? InfographicModel.get(row) : null;
      })
      .catch((error) => {
        console.log(error);
        return null;
      });
  }

  /** ใช้ตอน Preview จาก Strapi ซึ่งส่งมาเป็น documentId */
  async getSlugByDocumentId(documentId, status = "draft") {
    const query = qs.stringify(
      { filters: { documentId: { $eq: documentId } }, fields: ["Slug"], status },
      { encodeValuesOnly: true }
    );
    return await http
      .get("/infographics?" + query)
      .then((response) => response.data.data[0]?.Slug || null)
      .catch(() => null);
  }
})();
